import { render, staticRenderFns } from "./Comentarios.vue?vue&type=template&id=7d25bf51"
import script from "./Comentarios.vue?vue&type=script&lang=js"
export * from "./Comentarios.vue?vue&type=script&lang=js"
import style0 from "./Comentarios.vue?vue&type=style&index=0&id=7d25bf51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports